import React from "react";
import SVG from 'react-inlinesvg';

import bannerImage from '@src/images/backgrounds/landing-achievements-banner';

const Achievements = () => {
  return (
    <section className="achievements-section" id="achievements">
      <div className="achievements-section__header">
        <div className="achievements-section__header-heading">
          What Is DinoMath Olympiad?
        </div>
        <div className="achievements-section__header-text">
          Mind-bending puzzles and riddles to&nbsp;improve logical thinking skills in students
        </div>
      </div>
      <div className="achievements-section__banner">
        <div>
          <div className="achievements-section__banner-heading">
            5 Lakh Participants
          </div>
          <div className="achievements-section__banner-text">
            Students from across India<br/>
            have&nbsp;competed&nbsp;in&nbsp;DinoMath and they loved it!
          </div>
        </div>
        <div className="achievements-section__banner-image">
          <SVG src={bannerImage} className="text-center"/>
        </div>
      </div>
    </section>
  );
}

export default Achievements;
